import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MediaQuery from 'react-responsive';
import styles from './styles';

const FooterDivider = props => (
    <MediaQuery maxDeviceWidth={767}>
        {(matches) =>
            <React.Fragment>
                {!matches &&
                    <span className={props.classes.divider}>&bull;</span>
                }
            </React.Fragment>
        }
    </MediaQuery>
);

export default withStyles(styles)(FooterDivider);